import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';

export const UserRoleSchema = z.enum(['rep', 'manager']);
export type UserRole = z.infer<typeof UserRoleSchema>;

export const UserSchema = z.object({
  id: IdSchema,
  email: z.string().email(),
  name: z.string().min(1),
  role: UserRoleSchema,
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type User = z.infer<typeof UserSchema>;

export const PublicUserSchema = UserSchema.pick({ id: true, name: true, role: true });
export type PublicUser = z.infer<typeof PublicUserSchema>;

export const SignInSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
});
export type SignInInput = z.infer<typeof SignInSchema>;
